import { formatCurrencyToApi } from "@/utils";
import { Button, Flex, Text, Image } from "@chakra-ui/react";
import { SetStateAction } from "react";
import ModalAntecipacao from "./_ModalAntecipation";

interface SaldoComponentProps {
    data?: any;
    open?: React.Dispatch<SetStateAction<boolean>>
    openTransferList?: React.Dispatch<SetStateAction<boolean>>
    setUpdatedRedeens :React.Dispatch<SetStateAction<number>>
    updatedRedeens?: number
}

export function SaldoComponentAntecipation({ data, open, openTransferList,setUpdatedRedeens,updatedRedeens  }: SaldoComponentProps) {



    return (
        <Flex
            gap="16px"
        >
            <Flex
                borderRadius="8px"
                minW="299px"
                fontFamily="inter"
                gap="24px"
                h="71px"
                padding='16px 24px'
                align="center"
                justify="space-between"
                bgColor="white"
                boxShadow="md"
            >
                <Flex
                    flexDir="column"
                >
                    <Text fontSize="12px">Saldo a liberar</Text>
                    <Flex
                        position="relative"
                    >
                        <Text
                            fontSize="16px"
                            position="absolute"
                            bottom="15%"
                            fontWeight={400}
                        >
                            R$
                        </Text>
                        <Text
                            fontWeight={600}
                            color="black"
                            fontSize="21px"
                            marginLeft="1.5rem"
                        >
                            {data?.provisionedAmount.replace("R$", "")}
                        </Text>
                    </Flex>
                </Flex>

                <Flex
                    flexDir="column"
                    gap="8px"
                >
                    {/* <Button
                        variant="outline"
                        fontWeight="400"
                        w="118px"
                        h="32px"
                        fontSize="14px"
                        color="black"
                        onClick={() => open(true)}
                        disabled={formatCurrencyToApi(data?.amount) === 0 && formatCurrencyToApi(data?.provisionedAmount) === 0}
                    >
                        Antecipar
                    </Button> */}
                    <ModalAntecipacao 
                    updatedRedeens={updatedRedeens}
                    setUpdatedRedeens={setUpdatedRedeens}
                    data={data} />
                </Flex>
            </Flex>
            <Flex
                borderRadius="8px"
                minW="299px"
                fontFamily="inter"
                gap="24px"
                h="71px"
                padding='16px 24px'
                align="center"
                justify="space-between"
                bgColor="white"
                boxShadow="md"
            >
                <Flex
                    flexDir="column"
                >
                    <Text fontSize="12px">Saldo disponível</Text>
                    <Flex
                        position="relative"
                    >
                        <Text
                            fontSize="16px"
                            position="absolute"
                            bottom="15%"
                            fontWeight={400}
                        >
                            R$
                        </Text>
                        <Text
                            fontWeight={600}
                            color="black"
                            fontSize="21px"
                            marginLeft="1.5rem"
                        >
                            {data?.amount.replace("R$", "")}
                        </Text>
                    </Flex>
                </Flex>

                <Flex
                    flexDir="column"
                    gap="8px"
                >


                    <Button
                        variant="solid"
                        fontWeight="400"
                        w="93px"
                        h="32px"
                        fontSize="14px"
                        alignItems={"center"}
                        alignContent={"center"}
                        justifyContent={"center"}
                        display="flex"
                        gap="4px"
                        p="0"
                        backgroundColor="#CB2159"
                        color="white"
                        onClick={() => open(true)}
                        disabled={formatCurrencyToApi(data?.amount) === 0 && formatCurrencyToApi(data?.provisionedAmount) === 0}
                    >
                        <Image w="16px" h="16px" src={"/images/icons/WalletOutlined.svg"} />
                        Sacar
                    </Button>

                </Flex>
            </Flex>
        </Flex>
    )
}